import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Fuel, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { STATUS_COLORS } from "@/lib/statuses";

export default function MyOrders() {
    const [orders, setOrders] = useState(null);

    useEffect(() => {
        api.get("/orders/mine").then(r => setOrders(r.data.orders)).catch(() => setOrders([]));
    }, []);

    return (
        <div className="bg-slate-50 min-h-screen py-14" data-testid="my-orders-page">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
                    <div>
                        <div className="text-xs font-mono-plex uppercase tracking-[0.2em] text-blue-700 mb-3">// My Orders</div>
                        <h1 className="font-heading font-black text-4xl md:text-5xl tracking-tighter text-slate-900">Your deliveries.</h1>
                    </div>
                    <Link to="/order">
                        <Button className="rounded-sm bg-blue-700 hover:bg-blue-800 font-bold uppercase tracking-wider" data-testid="my-orders-new-btn">
                            New Order <ArrowRight className="ml-2 w-4 h-4" />
                        </Button>
                    </Link>
                </div>

                {orders === null && <Loader2 className="w-6 h-6 animate-spin text-blue-700" />}
                {orders && orders.length === 0 && (
                    <div className="bg-white border border-slate-200 rounded-sm p-16 text-center" data-testid="my-orders-empty">
                        <Fuel className="w-10 h-10 text-blue-700 mx-auto" />
                        <h2 className="mt-4 font-heading font-bold text-2xl tracking-tight text-slate-900">No orders yet.</h2>
                        <p className="mt-2 text-slate-600">Place your first order and we'll deliver diesel to your doorstep.</p>
                        <Link to="/order" className="mt-6 inline-block">
                            <Button className="rounded-sm bg-blue-700 hover:bg-blue-800 font-bold uppercase tracking-wider">Order Diesel</Button>
                        </Link>
                    </div>
                )}
                {orders && orders.length > 0 && (
                    <div className="bg-white border border-slate-200 rounded-sm overflow-hidden" data-testid="my-orders-list">
                        <table className="w-full text-sm">
                            <thead className="bg-slate-50 border-b border-slate-200">
                                <tr>
                                    <Th>Order #</Th><Th>Date</Th><Th>Qty</Th><Th>Address</Th><Th>Total</Th><Th>Status</Th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((o, i) => {
                                    const c = STATUS_COLORS[o.status] || STATUS_COLORS.Pending;
                                    return (
                                        <tr key={o.id} className={i % 2 === 1 ? "bg-slate-50" : ""} data-testid={`order-row-${o.order_number}`}>
                                            <Td><span className="font-mono-plex tab-num text-slate-900 font-bold">{o.order_number}</span></Td>
                                            <Td>{new Date(o.created_at).toLocaleDateString("en-IN")}</Td>
                                            <Td className="tab-num">{o.quantity_litres} L</Td>
                                            <Td className="max-w-xs truncate">{o.city}, {o.pincode}</Td>
                                            <Td className="tab-num font-bold">₹{o.total.toFixed(0)}</Td>
                                            <Td>
                                                <span className={`inline-block px-2 py-0.5 text-[11px] font-bold uppercase tracking-widest rounded-sm ${c.bg} ${c.text}`}>{o.status}</span>
                                            </Td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}

const Th = ({ children }) => <th className="text-left px-4 py-3 text-[10px] uppercase tracking-widest font-bold text-slate-600 font-mono-plex">{children}</th>;
const Td = ({ children, className = "" }) => <td className={`px-4 py-3 text-slate-700 ${className}`}>{children}</td>;
